import { Anchor, Stack, Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';

const SUPPORT_MAILTO = 'mailto:support@vdzm.de';

export function SidebarHelpCta() {
  return (
    <Anchor
      href={SUPPORT_MAILTO}
      underline="never"
      style={{
        display: 'block',
        padding: 'var(--mantine-spacing-sm) var(--mantine-spacing-md)',
        background: 'var(--mantine-color-vdzGray-6)',
        borderRadius: 'var(--mantine-radius-md)',
      }}
    >
      <Stack gap={6}>
        <Text fw={700} size="sm" c="white">
          Wir helfen Ihnen gerne
        </Text>
        <Text size="xs" c="white" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          Schreiben Sie uns <IconChevronRight size={12} />
        </Text>
      </Stack>
    </Anchor>
  );
}
